import { gt, equals, divide, subtract } from 'ramda';
import { ceil } from 'lodash';

export default ({ number, size }, totalItems, items) => (
  gt(totalItems, size)
  && equals(subtract(totalItems, items) % size, 0)
  && equals(ceil(divide(totalItems, size)), number)
);
